export default "__VITE_ASSET__8d3cce93__"